import { useState } from "react";
import { useCachedResource } from "../hooks/useCachedResource";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuCard } from "../components/neu/Neu";
import { SalesShell } from "../features/sales/SalesShell";
import { SalesRepRow } from "../features/sales/SalesRepRow";
import { approveCommission, saveRepPlan, saveRepTarget, teamPerformance } from "../api/salesInvoices";

const HEADS = ["rep", "invoices", "issued", "collected", "target", "achievement", "rate", "commission", "actions"];

// مندوبو المبيعات: أهداف شهرية · خطة عمولة · متابعة أداء · اعتماد العمولة.
export default function SalesRepsPage() {
  const { t } = useTranslation();
  const month = new Date().toISOString().slice(0, 7);
  const { data, reload: load } = useCachedResource(`sales-reps-${month}`, () => teamPerformance(month), [month]);
  const [edit, setEdit] = useState({});

  const save = async (row) => {
    const values = edit[row.rep_id] || {};
    if (values.target) await saveRepTarget({ rep_id: row.rep_id, month, amount: String(values.target) });
    if (values.rate) {
      await saveRepPlan({ rep_id: row.rep_id, kind: "flat", rate_percent: String(values.rate),
                          basis: "collected", active: true });
    }
    toast.success(t("sales.reps.saved"));
    load();
  };

  const approve = async (row) => {
    try {
      await approveCommission(row.rep_id, month);
      toast.success(t("sales.reps.approved"));
      load();
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    }
  };

  return (
    <SalesShell titleKey="reps">
      <NeuCard className="flex flex-wrap gap-3 p-4 text-xs" data-testid="reps-totals">
        <span className="rounded-full bg-primary/10 px-3 py-1 font-bold text-primary">
          {t("sales.reps.month")}: <span className="num">{month}</span>
        </span>
        <span className="rounded-full bg-primary/10 px-3 py-1 font-bold text-primary">
          {t("sales.reps.issued")}: <span className="num">{data?.totals.issued ?? "0.00"}</span>
        </span>
        <span className="rounded-full bg-primary/10 px-3 py-1 font-bold text-primary">
          {t("sales.reps.commission")}: <span className="num">{data?.totals.commission ?? "0.00"}</span>
        </span>
      </NeuCard>

      <NeuCard className="overflow-x-auto p-3" data-testid="reps-table">
        <table className="w-full min-w-[860px] text-start">
          <thead>
            <tr className="border-b border-border/60">
              {HEADS.map((head) => (
                <th key={head} className="p-2 text-start text-[11px] font-black text-muted-foreground">
                  {t(`sales.reps.table.${head}`)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(data?.rows || []).map((row) => (
              <SalesRepRow key={row.rep_id} row={row} edit={edit} setEdit={setEdit}
                           onSave={save} onApprove={approve} />
            ))}
          </tbody>
        </table>
      </NeuCard>
    </SalesShell>
  );
}
